var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".historia-1{fill:#464af0;}.historia-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chemia"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    className: "historia-1",
    cx: 18,
    cy: 18,
    r: 18
  })), /*#__PURE__*/React.createElement("path", {
    className: "historia-2",
    d: "M24.24,21.67V9H11.72C10.22,9,9,10.53,9,12.41v1.92h4.19V27H24.28c1.5,0,2.72-1.53,2.72-3.41V21.67Zm-14-8.58v-.68c0-1.17.68-2.17,1.48-2.17s1.47,1,1.47,2.17v.68Zm4.19,12.67V12.41a4,4,0,0,0-.62-2.17H23V21.67H17.38v1.92c0,1.17-.68,2.17-1.47,2.17Zm11.33-2.17c0,1.17-.68,2.17-1.48,2.17H18a4,4,0,0,0,.62-2.17v-.68h7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "historia-2",
    x: 15.99,
    y: 12.62,
    width: 5.49,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "historia-2",
    x: 15.99,
    y: 15.46,
    width: 5.49,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "historia-2",
    x: 15.99,
    y: 18.31,
    width: 5.49,
    height: 1.33
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoria);
export default __webpack_public_path__ + "static/media/historia.8af0a9a60633f6ef161ec0a698009427.svg";
export { ForwardRef as ReactComponent };